import { CallToAction, Section } from 'utils/types/contentfulTypes';

import { BannerAndToolCardsProps } from './BannerAndToolCards';

const buildBullets = (subsections: any) => {
  // Filter out subsections with the componentName "BannerAndToolsCards"
  const filteredBulletSubsection = subsections.filter(
    (sub: any) => sub?.componentName === 'BannerAndToolCards',
  );

  // Create bullets from the filtered subsections
  const bullets = filteredBulletSubsection.map((sub: any) => ({
    title: sub!.displayName,
    iconName: sub!.metadata!.context.icon,
  }));

  return bullets;
};

const buildToolCards = (subsections: any) => {
  if (!subsections || subsections.length === 0) {
    return [];
  }

  // Filter out subsections with the componentName "ToolCardV2"
  const filteredToolCardSubsection = subsections.filter(
    (sub: any) => sub?.componentName === 'ToolCardV2',
  );

  const toolCards = filteredToolCardSubsection.map((sub: any) => ({
    title: sub?.displayName || '',
    bgColor: sub?.metadata?.theme?.backgroundColor || '',
    textColor: sub?.metadata?.theme?.textColor || '',
    body: sub?.body || '',
    desktopBackgroundImage: sub?.images?.[0]?.desktopImage || '',
  }));

  return toolCards;
};

export const parseBannerAndToolCardsData = (
  contentfulSection: Section,
): BannerAndToolCardsProps | null => {
  const { displayName, body, images, subsections } = contentfulSection;
  const { title, theme, flags, ctas } = contentfulSection.metadata || {};

  const backgroundColor = theme?.backgroundColor;
  const desktopBackgroundImage = images && images[0]?.desktopImage;
  const desktopBackgroundImageAltText =
    images && images[0]?.desktopImageAltText;

  // Validate that all sections are added in Contentful
  if (
    !displayName ||
    !title ||
    !body ||
    !desktopBackgroundImage ||
    !desktopBackgroundImageAltText ||
    !backgroundColor
  ) {
    return null;
  }

  let bullets = null;

  // Check if there are icons in the metadata context
  if (subsections && subsections[0]?.metadata?.context?.icon) {
    bullets = buildBullets(subsections);
  }

  const toolCards = buildToolCards(subsections);

  const cta: CallToAction = {
    label: ctas?.[0]?.label || '',
    url: ctas?.[0]?.url || '',
    metadata: ctas?.[0]?.metadata || {},
  };

  const BannerAndToolCardsProps: BannerAndToolCardsProps = {
    eyebrow: displayName,
    title,
    bgColor: backgroundColor,
    headline: body,
    flags,
    desktopBackgroundImage,
    desktopBackgroundImageAltText,
    bullets,
    toolCards,
    cta,
  };

  return BannerAndToolCardsProps;
};
